import { FILE_UPLOAD_LIMIT_VIDEO } from 'shared/constants';
import { Plugin } from 'prosemirror-state';

export const uploadVideoPlugin = (uploader, hasStorage, fileTypes, eventBus) => new Plugin({
  props: {
    handleDOMEvents: {
      drop(view, event) {
        const hasFiles = event.dataTransfer.files.length > 0;
        if (!hasFiles) {
          return;
        }

        const files = Array.from(event.dataTransfer.files);
        const videos = files.filter((i) => fileTypes.includes(i.type));

        if (videos.length === 0) {
          return;
        }

        if (videos.length === files.length) {
          event.preventDefault();
        }

        const { schema } = view.state;
        const coordinates = view.posAtCoords({
          left: event.clientX,
          top: event.clientY,
        });
        let pos = coordinates.pos - 1;
        if (pos < 0) {
          pos = 0;
        }

        if (!hasStorage) {
          eventBus.emit('show-toast', {
            color: 'warning',
            message: 'Your storage is full. Please upgrade to upload more videos.',
          });
          return;
        }

        videos.forEach((video) => {
          if (!fileTypes.includes(video.type)) {
            return;
          }

          if (video.size > FILE_UPLOAD_LIMIT_VIDEO) {
            eventBus.emit('show-toast', {
              color: 'error',
              message: 'File is too big',
            });
            return;
          }

          const node = schema.nodes.video.create({
            src: '',
            size: video.size,
            name: video.name,
            video,
          });
          const transaction = view.state.tr.insert(pos, node);
          view.dispatch(transaction);

          pos += 1;
        });
      },
    },
  },
});
